export default __webpack_public_path__ + "static/media/GM_Cup_Haze.fd43f9e6.png";